export default "__VITE_ASSET__rpWxY_of__"